"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialStep = void 0;
var getInitialStep = function (options) {
    if (!options) {
        return 1;
    }
    if (typeof options === "number") {
        return options;
    }
    if (!!options && Array.isArray(options) && typeof options[0] !== "string") {
        throw new Error("Wizard: for now the entry step of the complex wizard must always be a simple string");
    }
    if (!!options && Array.isArray(options) && typeof options[0] === "string") {
        return options[0];
    }
    throw new Error("Wizard: initialStep could not be set...");
};
exports.getInitialStep = getInitialStep;
//# sourceMappingURL=getInitialStep.js.map